// extracted by mini-css-extract-plugin
export default {"Emoji":"bbl_a bhm_i bhm_q bhm_j"};